module.exports = "    <!-- begin::Scroll Top --> <div id=\"m_scroll_top\" class=\"m-scroll-top\" appunwraptag=\"\"> \t<i class=\"la la-arrow-up\"></i> </div> <!-- end::Scroll Top -->\t"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/layouts/scroll-top/scroll-top.component.html
// module id = ./src/app/theme/layouts/scroll-top/scroll-top.component.html
// module chunks = main